// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1EXBM","subheader":"ReorderModal_subheader__2rUe9","listWrap":"ReorderModal_listWrap__1Xrk3"};